import { Program, ProgramRequest } from "@/domain/program.interface";
import { instanceBo } from "../utils/axios.create";

const findProgramsByAccountId = async (): Promise<Program[]> => {
	return instanceBo
		.get("/programs")
		.then((res) => {
			return [...res.data.body.map((p: Program) => ({ ...p, id: p._id }))];
		})
		.catch((err) => {
			return Promise.reject(err.response.data);
		});
};

const patchProgramSetting = async (
	programId: string,
	todayDateAndTime: Date | null,
): Promise<{ message: string }> => {
	return instanceBo
		.patch(`/programs/${programId}/todayDateAndTime`, {
			todayDateAndTime: todayDateAndTime,
		})
		.then((res) => res.data.body)
		.catch((err) => Promise.reject(err.response.data));
};

const createProgram = async (
	accountId: string,
	programData: ProgramRequest,
): Promise<Program> => {
	return instanceBo
		.post("/programs", programData)
		.then((res) => res.data.body.program)
		.catch((err) => Promise.reject(err.response.data));
};

const updateProgram = async (
	programId: string,
	programData: ProgramRequest,
): Promise<Program> => {
	return instanceBo
		.put(`/programs/${programId}`, programData)
		.then((res) => res.data.body.program)
		.catch((err) => Promise.reject(err.response.data));
};

export const programService = {
	findProgramsByAccountId,
	patchProgramSetting,
	createProgram,
	updateProgram,
};
